import { render, staticRenderFns } from "./frontContactoContainer.vue?vue&type=template&id=b823f7e8&scoped=true&"
import script from "./frontContactoContainer.vue?vue&type=script&lang=js&"
export * from "./frontContactoContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b823f7e8",
  null
  
)

export default component.exports